import { iconSizeOptions } from '../stories/atoms/icons/icons-sizes'
import {
  SpinnerGrey,
  SpinnerIos,
  SpinnerOrange,
  SpinnerWhite
} from '../stories/atoms/icons/special'
import { LoadingComponentContainer } from './styled-components'

export const loadingComponentVariantOptions = {
  GREY: 'grey',
  IOS: 'ios',
  ORANGE: 'orange',
  WHITE: 'white'
}

const loadingComponentVariantComponents = {
  [loadingComponentVariantOptions.GREY]: SpinnerGrey,
  [loadingComponentVariantOptions.IOS]: SpinnerIos,
  [loadingComponentVariantOptions.ORANGE]: SpinnerOrange,
  [loadingComponentVariantOptions.WHITE]: SpinnerWhite
}

const LoadingComponent = ({
  variant = loadingComponentVariantOptions.GREY,
  size = iconSizeOptions['ICON-M'],
  ...props
}) => {
  const Component = loadingComponentVariantComponents[variant] || SpinnerGrey

  return (
    <LoadingComponentContainer {...props}>
      <Component size={size} />
    </LoadingComponentContainer>
  )
}

export default LoadingComponent
